export default __webpack_public_path__ + "static/media/play-btn.6b71a384.svg";